import React from 'react';
import { useSelector } from 'react-redux';
import T from 'prop-types';
import { get } from 'lodash-es';

import skeletons from './Skeletons';
import Tooltip from '../../../../Tooltip';
import Button from '../../../../Buttons/Button';
import ErrorStateWithReload from '../../../../ErrorStateWithReload';
import WidgetRanks from '../../../../../pages/app-insights/_shared/components/WidgetRanks';
import InsightsCardBox from '../../../../../pages/app-insights/_shared/components/InsightsCardBox';

import { quickViewDataSelector } from '../../../selectors';
import links from '../../../configs/links';

const Ranks = ({ store, ref_no, settings }) => {
  const data = useSelector(quickViewDataSelector);
  const { error } = settings;

  const ranks = get(data, 'widgets.ranks', {});
  if (error) return <ErrorStateWithReload />;

  return (
    <InsightsCardBox
      headerLeft={(
        <div className="paragraph">
          Ranks
          <Tooltip content="When multiple countries are selected, this shows the number of countries the app is ranking in within the category over the number of countries selected.">
            <span className="cursor-pointer tooltip-icon">
              <i className="hicon-question-circle" />
            </span>
          </Tooltip>
        </div>
      )}
      headerRight={(
        <Button variant="secondary" size="sm" href={links.ranks(store, ref_no)}>
          Go to Ranks
        </Button>
      )}
      bodyMinHeight={85}
      className="ranks-section"
    >
      {settings.pending
        ? skeletons.widgetRanks
        : <WidgetRanks widgetData={{ ranks }} appStore={store} />}
    </InsightsCardBox>
  );
};

Ranks.propTypes = {
  store: T.string,
  ref_no: T.oneOfType([T.string, T.number]),
  settings: T.object,
};

export default Ranks;
